import { WCharacterFormat, WParagraphFormat } from '../format/index';
import { WList } from '../list/list';
import { WAbstractList } from '../list/abstract-list';
import { WListLevel } from '../list/list-level';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * List view model implementation
 *
 * @private
 */
export class ListViewModel {
    /**
     * @private
     */
    constructor() {
        this.listIn = undefined;
        this.levelNumberIn = undefined;
        this.dialog = undefined;
        this.levelNumber = 0;
    }
    get levelNumber() {
        return this.levelNumberIn;
    }
    set levelNumber(value) {
        this.levelNumberIn = value;
    }
    get list() {
        return this.listIn;
    }
    set list(value) {
        if (isNullOrUndefined(value)) {
            this.createList();
        }
        else {
            this.listIn = value;
        }
    }
    get listLevel() {
        if (!isNullOrUndefined(this.list) && this.levelNumber >= 0 && this.levelNumber < 9) {
            if (!isNullOrUndefined(this.dialog.documentHelper.getAbstractListById(this.list.abstractListId))) {
                if (this.dialog.documentHelper.getAbstractListById(this.list.abstractListId).levels.length <= this.levelNumber) {
                    this.dialog.documentHelper.layout.addListLevels(this.list.abstractList);
                }
                return this.dialog.documentHelper.getAbstractListById(this.list.abstractListId).levels[this.levelNumber];
            }
            else {
                this.dialog.documentHelper.lists.push(this.list);
                let abstractList = this.list.abstractList;
                if (!this.list.abstractList) {
                    abstractList = new WAbstractList();
                    abstractList.abstractListId = this.list.abstractListId;
                }
                this.dialog.documentHelper.abstractLists.push(abstractList);
                abstractList = this.dialog.documentHelper.getAbstractListById(this.list.abstractListId);
                if (abstractList.levels.length <= this.levelNumber) {
                    this.dialog.documentHelper.layout.addListLevels(this.list.abstractList);
                }
                return abstractList.levels[this.levelNumber];
            }
        }
        return undefined;
    }
    get listLevelPattern() {
        if (!isNullOrUndefined(this.listLevel)) {
            return this.listLevel.listLevelPattern;
        }
        return 'Arabic';
    }
    set listLevelPattern(value) {
        if (!isNullOrUndefined(this.listLevel)) {
            this.listLevel.listLevelPattern = value;
        }
    }
    get followCharacter() {
        if (!isNullOrUndefined(this.listLevel)) {
            return this.listLevel.followCharacter;
        }
        return 'None';
    }
    set followCharacter(value) {
        if (!isNullOrUndefined(this.listLevel)) {
            this.listLevel.followCharacter = value;
        }
    }
    createList() {
        this.list = new WList();
        this.list.listId = this.dialog.documentHelper.lists.length + 1;
        const abstractList = new WAbstractList();
        abstractList.abstractListId = this.dialog.documentHelper.abstractLists.length + 1;
        this.list.abstractListId = abstractList.abstractListId;
        this.list.abstractList = abstractList;
        this.dialog.documentHelper.lists.push(this.list);
        const listLevel = new WListLevel(abstractList);
        listLevel.paragraphFormat = new WParagraphFormat(listLevel);
        listLevel.paragraphFormat.leftIndent = 48;
        listLevel.paragraphFormat.firstLineIndent = -24;
        listLevel.characterFormat = new WCharacterFormat(listLevel, this.dialog.documentHelper.owner);
        listLevel.numberFormat = '%1.';
        listLevel.startAt = 1;
        abstractList.levels.push(listLevel);
        this.dialog.documentHelper.abstractLists.push(abstractList);
    }
    addListLevels() {
        if (!isNullOrUndefined(this.list) && !isNullOrUndefined(this.list.abstractListId)) {
            for (let i = this.dialog.documentHelper.getAbstractListById(this.list.abstractListId).levels.length; i < 9; i++) {
                const listLevelAdv = new WListLevel(this.dialog.documentHelper.getAbstractListById(this.list.abstractListId));
                listLevelAdv.characterFormat = new WCharacterFormat(listLevelAdv, this.dialog.documentHelper.owner);
                listLevelAdv.paragraphFormat = new WParagraphFormat(listLevelAdv);
                listLevelAdv.paragraphFormat.leftIndent = (i + 1) * 48;
                listLevelAdv.paragraphFormat.firstLineIndent = -24;
                listLevelAdv.numberFormat = '%' + (i + 1).toString() + '.';
                listLevelAdv.listLevelPattern = 'Arabic';
                listLevelAdv.followCharacter = 'Tab';
                listLevelAdv.startAt = 1;
                listLevelAdv.restartLevel = i;
                (this.dialog.documentHelper).getAbstractListById(this.list.abstractListId).levels.push(listLevelAdv);
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        if (this.dialog && this.listIn) {
            this.dialog.documentHelper.layout.clearInvalidList(this.listIn);
        }
        this.listIn = undefined;
        this.levelNumberIn = undefined;
        this.listLevelPattern = undefined;
    }
}
